import { Component, OnInit } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { TranslateService } from "@ngx-translate/core";
import utilityCommon from "app/core/utility/utility-common";
@Component({
  selector: "cz-terms-of-use",
  templateUrl: "./terms-of-use.component.html",
  styleUrls: ["./terms-of-use.component.scss"],
})
export class TermsOfUseComponent implements OnInit {
  constructor(
    private _translateService: TranslateService,
    private readonly _snackBar: MatSnackBar
  ) {}

  public ngOnInit(): void {}

  public downloadPDF(): void {
    this.showSnackBar(this._translateService.instant("$pdf_download"));
    utilityCommon.pdfTermsDownloadinSafari(1);
  }

  public showSnackBar(message: string): void {
    this._snackBar.open(message, undefined, {
      duration: 5000,
    });
  }

  /**
   * Opens a new browser tab pointing to the login route with a query param
   * that will auto-open the Privacy Policy dialog on load.
   */
  public openPrivacyPolicyNewTab(): void {
    const base: string = window.location.origin + window.location.pathname;
    const url: string =
      base +
      (base.indexOf("?") === -1
        ? "?openPrivacyPolicy=true"
        : "&openPrivacyPolicy=true");
    window.open(url, "_blank", "noopener");
  }
}
